import { MapPin, Users, CheckCircle, Clock } from 'lucide-react';

export const NAV_LINKS = [
  { label: 'How It Works', href: '#how-it-works', page: null },
  { label: 'For Creators',  href: '#creators',     page: null },
  { label: 'About Us',      href: null,            page: 'about' },
];

export const USER_TYPE_OPTIONS = [
  { value: 'food-creator',  label: '🍳 Food Creator' },
  { value: 'kitchen-owner', label: '🏢 Kitchen Owner' },
  { value: 'both',          label: '👥 Both' },
];

export const WAITLIST_PERKS = [
  '✨ Early access',
  '💰 Special pricing',
];

export const MARQUEE_ITEMS = [
  'Commercial Kitchens',
  'Restaurant Spaces',
  'Bakery Equipment',
  'Pop-up Locations',
  'Shared Kitchens',
  'Catering Facilities',
];

export const HOW_IT_WORKS_STEPS = [
  {
    icon: MapPin,
    step: '1',
    title: 'List',
    desc: 'Kitchen owners list their available spaces with photos, equipment details, and availability.',
    gradient: 'from-red-600 to-red-700',
  },
  {
    icon: Users,
    step: '2',
    title: 'Discover',
    desc: 'Food creators browse and filter kitchens by location, equipment, price, and availability.',
    gradient: 'from-red-700 to-red-800',
  },
  {
    icon: CheckCircle,
    step: '3',
    title: 'Connect',
    desc: 'Secure booking with instant confirmation, payment processing, and ongoing support.',
    gradient: 'from-red-800 to-red-900',
  },
];

export const WHY_STOVESHARE = [
  {
    title: 'Flexible Terms',
    desc: 'Book by the hour, day, week, or month',
    highlight: 'No long-term contracts',
    icon: Clock,
    gradient: 'from-red-500 to-red-600',
  },
  {
    title: 'Prime Locations',
    desc: 'Kitchens in food-friendly neighbourhoods',
    highlight: 'Reduce delivery costs',
    icon: MapPin,
    gradient: 'from-red-600 to-red-700',
  },
  {
    title: 'Instant Approval',
    desc: 'Quick verification and same-day booking',
    highlight: 'Start cooking today',
    icon: CheckCircle,
    gradient: 'from-red-700 to-red-800',
  },
];

export const FOOD_CREATOR_BENEFITS = [
  'Find affordable, short-term kitchen rentals',
  'Book by the hour, day, or week',
  'Access professional-grade equipment',
  'Flexible scheduling and instant booking',
  'Connect with local food community',
];

export const KITCHEN_OWNER_BENEFITS = [
  'Monetize unused kitchen capacity',
  'Easy listing and availability management',
  'Support local food entrepreneurs',
  'Enable split-use with multiple tenants',
  'Secure payments and insurance coverage',
];

export const COMPANY_INFO = {
  name: 'StoveShare',
  legalName: 'Stove Share (ABN 66873614741)',
  email: 'info@stoveshare.com.au',
  website:'https://stoveshare.com.au/',
  supportEmail: 'support@stoveshare.com.au',
  effectiveDate: '22 September 2023',
};
